// ShowStandardCheck — the tree's "Standard" box on Catalog and Products (Alex,
// 2026-10-15). It sits on the tree's Filter row, right of the input (Alex: "Can show
// standard be only 'Standard' and beside the tree 'Filter'").
// Working in a project, the tree and grid start as that project's OWN rows
// only (unticked, every time); ticking brings Standard back. Alex flipped it on purpose:
// "Untick (default) and tick is for see everything."
//
// Renders nothing when Working in is Standard — there is no "own" to filter to.
// The state belongs to the screen; App remounts the screen on a new Working in, which
// is what puts the box back to unticked.
import Text from './Text.jsx';

export default function ShowStandardCheck({ workingCode, checked, onChange }) {
  return (
    <label
      title={checked
        ? `Showing Standard and ${workingCode || 'this project'}'s own rows. Untick to see only ${workingCode || 'the project'}'s own.`
        : `Showing only ${workingCode || 'this project'}'s own rows. Tick to see Standard too.`}
      style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0, cursor: 'pointer' }}
    >
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
      <Text kind="note">Standard</Text>
    </label>
  );
}

// The empty-tree sentence, so both screens say the same thing.
export function nothingOwnMessage(workingCode) {
  return `Nothing belongs to ${workingCode || 'this project'} yet — tick Standard to see the rest.`;
}
